<template>
    <div class="dropdown-menu mt-4 p-0 priceDpMenu dpMenu" style="width: 350px;">
        <div class="cropspage__items__dropdown">
            <div class="closeItem">
                <a href="#" @click.prevent="cancel">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
                    fill="#959595" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                    fill="#959595" />
                </svg>
                </a>
            </div>
            <div class="row">
                <h4 class="font-bold font-sm margin_top_md caps_upper">Avr. Price per Ton</h4>
            </div>
            <div class="margin_top_lg">
                <vue-slider v-model="value" @change="changeSlider" :maxRange="10000000" :max="10000000"></vue-slider>
            </div>
            <div class="margin_top_lg">
                <div class="text-center">
                    <h5 class="font-bold"><span class="naira"></span> {{minValue | formatNumber}} - <span class="naira"></span> {{maxValue | formatNumber}}</h5>
                </div>
            </div>
            <div class="row d-flex justify-content-end margin_top_md">
                <button class="btn btn-sm btn-default" @click="cancel"> Cancel</button>
                <submit-button class="btn btn-sm btn-secondary mr-2" :loading="filtering" @click="apply">Apply</submit-button>
            </div>
        </div>
        
    </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

export default {
    props: ['filtering'],
    data() {
        return {
            value: [0, 550000],
            minValue: 0,
            maxValue: 550000
        }
    },
    methods: {
        cancel(){
            // window.$('.open_price').attr('data-toggle', 'dropdown')
            this.value = [0, 550000];
            this.$emit('priceValues', this.value)
            window.$('.priceDpMenu').removeClass('show')
            window.$('#myPriceDropDown').removeClass('show')
        },
        changeSlider(value) {
            this.minValue = value[0];
            this.maxValue = value[1];
            // this.$emit('filterPrice', value)
        },
        apply() {
            this.$emit('priceValues', this.value)
        }
    },
    components: {
        VueSlider
    }
}
</script>

<style>

</style>